import { API } from "../../Services/Api"

const request = new API()

export const refreshToken = ({ token }) => {
  const req = request.api.post("auth/token/refresh/", {
    refresh: token
  })

  return req
}

export const verifyToken = ({ token }) => {
  const req = request.api.post("auth/token/verify/", {
    token
  })

  return req
}

export const verifyAdminInviteToken = ({ token }) => {
  return request.api.get('/admin_panel/admin-users/verify-invite/', {
    token,
  });
};

export const validateConfirmCode = ({ code }) => {
  return request.api.get('/user/validate-confirm-code/', {
    code,
  });
};

export const changeAdminPassword = (params) => {
  return request.api.post(`/auth/required-password-change/`, params)
}
